<script setup lang="ts">
import spritePath from '~/assets/icons/svg/icons.svg?raw';
</script>

<template>
    <!-- eslint-disable vue/no-v-html -->
    <div
        class="sprites"
        v-html="spritePath"
    />
    <!-- eslint-enable -->
</template>

<style scoped lang="scss">
.sprites {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
}
</style>